import { useI18n } from "../i18n";
import { prefs } from "../lib/prefs";
import { play } from "../lib/sfx";
import { useStore } from "../lib/store";
import { Toggle } from "./Controls";
import { LangSwitch } from "./LangSwitch";
import { Sheet } from "./Sheet";

export function PrefsSheet({ open, onClose }: { open: boolean; onClose(): void }) {
  const { d } = useI18n();
  const p = useStore(prefs);
  return (
    <Sheet open={open} onClose={onClose} title={d.prefs.title} size="narrow">
      <div className="space-y-4">
        <div>
          <span className="label">{d.prefs.language}</span>
          <LangSwitch />
        </div>
        <Toggle checked={p.sound} onChange={(v) => prefs.set((s) => ({ ...s, sound: v }))} label={d.prefs.sound} />
        <Toggle
          checked={p.narrator ?? true}
          onChange={(v) => prefs.set((s) => ({ ...s, narrator: v }))}
          label={d.prefs.narrator}
          hint={d.prefs.narratorHint}
        />
        <Toggle checked={p.haptics} onChange={(v) => prefs.set((s) => ({ ...s, haptics: v }))} label={d.prefs.haptics} />
        <div>
          <span className="label">{d.prefs.volume}</span>
          <input
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={p.volume}
            onChange={(e) => prefs.set((s) => ({ ...s, volume: Number(e.target.value) }))}
            onPointerUp={() => play("ding")}
            className="w-full accent-[var(--color-flame)]"
            aria-label={d.prefs.volume}
          />
        </div>
      </div>
    </Sheet>
  );
}
